// extracted by mini-css-extract-plugin
module.exports = {"pageLogo":"jgp-1EzKF"};